import backendApi from '@/services/backend.service'
import store from '../../store'
import router from '../../router'
import { identifyPostHogUser, resetPostHog } from '@/plugins/posthog'

function persistPrivacyPolicyPayload(loginData) {
  if (!loginData.privacy_policy) {
    return
  }

  sessionStorage.setItem(
    'privacy_policy_payload',
    JSON.stringify({
      ...loginData.privacy_policy,
      needs_privacy_consent: loginData.needs_privacy_consent,
    })
  )
}

function persistTemporaryLoginSession(loginData) {
  $cookies.set('tmp_token', loginData.access_token)
  $cookies.set('tmp_user', loginData.user)
  $cookies.set('tmp_services', loginData.services)
  $cookies.set('tmp_chat_roles', loginData.chat_roles)
  $cookies.set(
    'tmp_needs_privacy_consent',
    Boolean(loginData.needs_privacy_consent)
  )
  persistPrivacyPolicyPayload(loginData)
}

function persistAuthenticatedSession(loginData) {
  $cookies.set('user', loginData.user)
  $cookies.set('token', loginData.access_token)
  $cookies.set('services', loginData.services)
  $cookies.set('chat_roles', loginData.chat_roles)
  $cookies.set(
    'needs_privacy_consent',
    Boolean(loginData.needs_privacy_consent)
  )
  $cookies.remove('is_impersonated_session')
  persistPrivacyPolicyPayload(loginData)
  identifyPostHogUser(loginData.user)
}

function handleDisabledAccount() {
  const message = 'Su cuenta ha sido deshabilitada'
  store.commit('setUser', null)
  store.commit('setErrorMessages', message)
}

function handleSuccessfulLogin(loginData) {
  if (loginData.user.status === 0) {
    handleDisabledAccount()
    return
  }

  if (loginData.need_two_factor_auth) {
    persistTemporaryLoginSession(loginData)
    store.commit('setErrorMessages', null)
    router.push({ path: '/two_factor_auth' })
    return
  }

  persistAuthenticatedSession(loginData)
  store.commit('setErrorMessages', null)
  router.push({ path: '/dashboard/analytics' })
}

function getLoginErrorMessage(error) {
  if (error.response?.data?.message) {
    return error.response.data.message
  }

  return 'No pudimos conectarnos con el servidor'
}

export default {
  state: {
    loadingAuth: false,
    errorMessages: null,
  },
  getters: {
    loading: (state) => state.loadingAuth,
    errorMessages: (state) => state.errorMessages,
  },
  mutations: {
    setLoadingAuth(state, payload) {
      state.loadingAuth = payload;
    },
    setErrorMessages(state, payload) {
      state.errorMessages = payload;
    },
  },
  actions: {
    async login({ commit }, user) {
      commit('setLoadingAuth', true)
      try {
        const response = await backendApi.post('/login', {
          email: user.email,
          password: user.password,
          recaptcha: user.recaptcha,
        })

        if (!response.data.success) {
          const message = response.data.message || 'No se pudo iniciar sesión'
          store.commit('setErrorMessages', message)
          return
        }

        handleSuccessfulLogin(response.data.data)
      } catch (error) {
        store.commit('setErrorMessages', getLoginErrorMessage(error))
      } finally {
        commit('setLoadingAuth', false)
      }
    },
    logout() {
      resetPostHog();
      $cookies.remove('user');
      $cookies.remove('token');
      $cookies.remove('services');
      $cookies.remove('chat_roles');
      $cookies.remove('needs_privacy_consent');
      $cookies.remove('is_impersonated_session');
      sessionStorage.removeItem('privacy_policy_payload');
      $cookies.remove('userRoles');

      router.push({ name: 'auth-signin' });
    },
  },
};
